import { render, staticRenderFns } from "./TabCompleted.vue?vue&type=template&id=ea1f4752"
import script from "./TabCompleted.vue?vue&type=script&lang=js"
export * from "./TabCompleted.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports